module.exports = __webpack_public_path__ + "img/crown1.0ae57ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/community/crown1.png
// module id = L/fZ
// module chunks = 15